import Box from 'components/shared/Box'
import PersonCredentials, {
    HandleInputProps,
} from 'components/shared/PersonCredentials'
import BungalowWrapper from 'components/shared/BungalowWrapper'
import { useAppDispatch } from 'store/hooks'
import { BungalowInfo, setGuestDetails } from 'store/accommodation-slice'

interface BungalowDetailsProps {
    bungalowIndex: number
    allGuestDetails: BungalowInfo
}

const BungalowDetails = ({
    bungalowIndex,
    allGuestDetails,
}: BungalowDetailsProps) => {
    const dispatch = useAppDispatch()
    const { adults, kids, infants } = allGuestDetails
    const handleInputChange = ({
        group,
        index,
        id,
        value,
    }: HandleInputProps) => {
        dispatch(
            setGuestDetails({
                field: id,
                bungalowIndex,
                index,
                value,
                type: group,
            })
        )
    }

    return (
        <BungalowWrapper index={bungalowIndex}>
            <Box gap={24} isFullWidth mt={[24, 40]}>
                {adults.map((person, index) => (
                    <PersonCredentials
                        name={person.name}
                        surname={person.surname}
                        key={`adults${bungalowIndex}-${index}`}
                        index={index}
                        group="adults"
                        bungalowIndex={bungalowIndex}
                        handleInputChange={handleInputChange}
                    />
                ))}
                {kids.map((person, index) => (
                    <PersonCredentials
                        name={person.name}
                        surname={person.surname}
                        key={`kids${bungalowIndex}-${index}`}
                        index={index}
                        group="kids"
                        bungalowIndex={bungalowIndex}
                        handleInputChange={handleInputChange}
                    />
                ))}
                {infants.map((person, index) => (
                    <PersonCredentials
                        name={person.name}
                        surname={person.surname}
                        key={`infants${bungalowIndex}-${index}`}
                        index={index}
                        group="infants"
                        bungalowIndex={bungalowIndex}
                        handleInputChange={handleInputChange}
                    />
                ))}
            </Box>
        </BungalowWrapper>
    )
}

export default BungalowDetails
